import React, { useState } from "react";
import DisplayImage from "../../display-image/DisplayImage";

const PicsDisplay = ({ data, websiteData }) => {
  const [index, setIndex] = useState(0);
  const [hover, setHover] = useState(null);
  return (
    <div
      style={{
        width: "100%",
        paddingTop: 40,
        paddingBottom: 40,
        display: "flex",
        position: "relative",
      }}
    >
      <div
        onMouseOver={() => setHover("left")}
        onMouseOut={() => setHover(null)}
        style={{
          flex: 0.25,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          onClick={() => setIndex(index === 0 ? 0 : index - 1)}
          style={{
            height: hover === "left" ? 50 : 40,
            transition: "all 0.3s",
            marginRight: 20,
            position: "absolute",
          }}
          src={require("../../../images/material-icons/backLeftBlack.png")}
        />
      </div>
      <div
        style={{
          flex: 0.5,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      ></div>

      <div
        onMouseOver={() => setHover("right")}
        onMouseOut={() => setHover(null)}
        style={{
          flex: 0.25,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          onClick={() => setIndex(index === 4 ? 0 : index + 1)}
          style={{
            height: hover === "right" ? 50 : 40,
            transition: "all 0.3s",
            transform: `rotate(180deg)`,
            marginLeft: 20,
            position: "absolute",
          }}
          src={require("../../../images/material-icons/backLeftBlack.png")}
        />
      </div>
    </div>
  );
};

export default PicsDisplay;
